(() => {
  'use strict';
  const configElement = document.getElementById('ss-gift-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const strings = JSON.parse(document.getElementById('ss-gift-strings').textContent);
  const dialog = document.getElementById('ss-gift-dialog');
  const template = document.getElementById('ss-gift-cart-template');
  const masks = config.masks.filter(mask => mask.id && mask.variantId);
  if (!dialog || masks.length !== 4) return;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const maskIds = new Set(masks.map(mask => Number(mask.id)));
  let state = config.state;
  let observed = signature(state.cart);
  let work = Promise.resolve();
  let busy = false;
  let queuedOpen = false;
  let lastFocus = null;

  function signature(cart) {
    return JSON.stringify([cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  }

  function gifts(cart) {
    return cart.items.filter(item => maskIds.has(Number(item.product_id)));
  }

  async function readState() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'ss-halloween-gift-state');
    const response = await fetch(url.toString(), {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error(strings.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const element = html.querySelector('[data-ss-gift-state]');
    if (!element) throw new Error(strings.error);
    return JSON.parse(element.textContent);
  }

  async function update(updates) {
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || strings.error);
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    return result;
  }

  function showStatus(message) {
    dialog.querySelector('[data-ss-gift-status]').textContent = message || '';
  }

  function paint() {
    const gift = gifts(state.cart)[0];
    const model = gift && masks.find(mask => Number(mask.variantId) === Number(gift.variant_id));
    const free = gift && gift.final_line_price === 0;
    dialog.querySelectorAll('[data-ss-gift-pick]').forEach(button => {
      const selected = gift && Number(button.dataset.ssGiftPick) === Number(gift.variant_id);
      const available = masks.some(mask => String(mask.variantId) === button.dataset.ssGiftPick && mask.available);
      button.disabled = busy || !available || state.pairs < 1;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.querySelector('.ss-gift-card-action').textContent = selected ? strings.selected : strings.choose;
    });
    const holders = [...document.querySelectorAll('[data-foot-holder], [data-ss-gift-cart-slot]')];
    holders.forEach(holder => {
      if (!holder.querySelector('[data-ss-gift-cart]')) holder.prepend(template.content.cloneNode(true));
    });
    document.querySelectorAll('[data-ss-gift-cart]').forEach(widget => {
      widget.hidden = state.pairs < 1;
      const image = widget.querySelector('[data-ss-gift-cart-image]');
      image.hidden = !model;
      if (model) {image.src = model.image; image.alt = model.name;}
      widget.querySelector('[data-ss-gift-cart-title]').textContent = free ? strings.cart_added : strings.cart_choose;
      widget.querySelector('[data-ss-gift-cart-name]').textContent = model ? model.name : strings.cart_text;
      widget.querySelector('[data-ss-gift-cart-price]').hidden = !free;
      widget.querySelector('[data-ss-gift-open]').textContent = model ? strings.change : strings.choose;
      widget.querySelector('[data-ss-gift-open]').disabled = busy;
    });
  }

  function close() {
    if (busy) return;
    dialog.close();
    if (lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll: true});
  }

  function open() {
    if (state.pairs < 1 || busy) return;
    lastFocus = document.activeElement;
    document.querySelectorAll('dialog[data-ss-quickview][open]').forEach(element => element.close());
    showStatus('');
    paint();
    if (!dialog.open) dialog.showModal();
  }

  async function reconcile(openAfterAdd) {
    const previousPairs = state.pairs;
    state = await readState();
    const lines = gifts(state.cart);
    const updates = {};
    if (state.pairs < 1) {
      lines.forEach(item => {updates[item.key] = 0;});
    } else {
      lines.forEach((item, index) => {
        if (index > 0 || item.quantity !== 1) updates[item.key] = index === 0 ? 1 : 0;
      });
    }
    if (Object.keys(updates).length) {
      await update(updates);
      state = await readState();
    }
    observed = signature(state.cart);
    paint();
    if (state.pairs < 1 && dialog.open) close();
    if (state.pairs > previousPairs && !gifts(state.cart).length) open();
  }

  function enqueue(task) {
    work = work.then(task).catch(() => {
      showStatus(strings.error);
      paint();
    });
    return work;
  }

  async function select(variantId) {
    const model = masks.find(mask => String(mask.variantId) === String(variantId) && mask.available);
    if (!model || busy) return;
    busy = true;
    dialog.querySelectorAll('[data-ss-gift-pick]').forEach(button => {
      button.classList.toggle('ss-gift-picking', button.dataset.ssGiftPick === String(model.variantId));
    });
    showStatus(strings.adding);
    paint();
    try {
      state = await readState();
      if (state.pairs < 1) throw new Error(strings.need_pair);
      const updates = {};
      gifts(state.cart).forEach(item => {updates[item.key] = 0;});
      updates[String(model.variantId)] = 1;
      await update(updates);
      state = await readState();
      const chosen = gifts(state.cart).find(item => Number(item.variant_id) === Number(model.variantId));
      if (!chosen || chosen.final_line_price !== 0) {
        const remove = {};
        gifts(state.cart).forEach(item => {remove[item.key] = 0;});
        if (Object.keys(remove).length) await update(remove);
        state = await readState();
        throw new Error(strings.discount_error);
      }
      observed = signature(state.cart);
      busy = false;
      paint();
      showStatus('');
      close();
      document.dispatchEvent(new CustomEvent('sneakstyle:gift:selected', {bubbles: true}));
    } catch (error) {
      busy = false;
      paint();
      showStatus(error.message || strings.error);
    } finally {
      dialog.querySelectorAll('.ss-gift-picking').forEach(button => button.classList.remove('ss-gift-picking'));
    }
  }

  document.addEventListener('sneakstyle:cart:realtime-sync', event => {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    if (signature(cart) === observed) {paint(); return;}
    observed = signature(cart);
    queuedOpen = queuedOpen || /add/.test(event.detail.reason || '');
    enqueue(async () => {
      const shouldOpen = queuedOpen;
      queuedOpen = false;
      await reconcile(shouldOpen);
    });
  });
  document.addEventListener('click', event => {
    const pick = event.target.closest('[data-ss-gift-pick]');
    if (pick) {event.preventDefault(); enqueue(() => select(pick.dataset.ssGiftPick)); return;}
    if (event.target.closest('[data-ss-gift-open]')) {
      event.preventDefault();
      enqueue(async () => {await reconcile(false); open();});
      return;
    }
    if (event.target.closest('[data-ss-gift-close]')) close();
  });
  dialog.addEventListener('cancel', event => {if (busy) event.preventDefault();});
  dialog.addEventListener('click', event => {if (event.target === dialog) close();});
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) new MutationObserver(paint).observe(drawer, {childList: true});
  document.addEventListener('theme:cart:open', paint);
  window.addEventListener('pageshow', event => {if (event.persisted) enqueue(() => reconcile(false));});
  paint();
  if (gifts(state.cart).length) enqueue(() => reconcile(false));
})();
